import { createContext, useContext, useRef } from 'react';
import useResizeObserver from 'use-resize-observer';

type PanelAreaRef = React.MutableRefObject<{
    width: number;
    height: number;
    resizeObserverRef: React.MutableRefObject<Element | null>;
}>;

const PanelAreaContext = createContext<undefined | PanelAreaRef>(undefined);

export function PanelAreaProvider(props: { children: React.ReactNode }) {
    const resizeObserverRef = useRef<Element | null>(null);
    const panelAreaContextValue = useRef<PanelAreaRef['current']>({
        width: 0,
        height: 0,
        resizeObserverRef,
    });
    useResizeObserver({
        ref: resizeObserverRef,
        onResize: ({ width, height }) => {
            if (width && height) {
                panelAreaContextValue.current.width = width;
                panelAreaContextValue.current.height = height;
            }
        },
    });
    return (
        <PanelAreaContext.Provider value={panelAreaContextValue}>
            {props.children}
        </PanelAreaContext.Provider>
    );
}

export function usePanelArea() {
    const value = useContext(PanelAreaContext);
    if (!value) throw new Error('Unexpectedly did not find value for PanelAreaContext');
    return value;
}
